/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GuestInvoiceData } from './GuestInvoiceData';
import {
    GuestInvoiceDataFromJSON,
    GuestInvoiceDataFromJSONTyped,
    GuestInvoiceDataToJSON,
} from './GuestInvoiceData';

/**
 * 
 * @export
 * @interface DigitalBillMetadataDto
 */
export interface DigitalBillMetadataDto {
    /**
     * 
     * @type {number}
     * @memberof DigitalBillMetadataDto
     */
    numberOfGuests?: number;
    /**
     * 
     * @type {string}
     * @memberof DigitalBillMetadataDto
     */
    tableName?: string;
    /**
     * 
     * @type {GuestInvoiceData}
     * @memberof DigitalBillMetadataDto
     */
    invoiceData?: GuestInvoiceData;
    /**
     * 
     * @type {string}
     * @memberof DigitalBillMetadataDto
     */
    origin?: string;
}

/**
 * Check if a given object implements the DigitalBillMetadataDto interface.
 */
export function instanceOfDigitalBillMetadataDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DigitalBillMetadataDtoFromJSON(json: any): DigitalBillMetadataDto {
    return DigitalBillMetadataDtoFromJSONTyped(json, false);
}

export function DigitalBillMetadataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitalBillMetadataDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'numberOfGuests': !exists(json, 'numberOfGuests') ? undefined : json['numberOfGuests'],
        'tableName': !exists(json, 'tableName') ? undefined : json['tableName'],
        'invoiceData': !exists(json, 'invoiceData') ? undefined : GuestInvoiceDataFromJSON(json['invoiceData']),
        'origin': !exists(json, 'origin') ? undefined : json['origin'],
    };
}

export function DigitalBillMetadataDtoToJSON(value?: DigitalBillMetadataDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'numberOfGuests': value.numberOfGuests,
        'tableName': value.tableName,
        'invoiceData': GuestInvoiceDataToJSON(value.invoiceData),
        'origin': value.origin,
    };
}

